import { computed } from "vue";
import { u as useColors } from "../../../composables/useColors-cd2c0b98.mjs";
const useCarouselColor = () => {
  const { setHSLAColor, getColor } = useColors();
  return {
    computedColor: computed(() => setHSLAColor(getColor("background-element"), { a: 0.7 })),
    computedHoverColor: computed(() => setHSLAColor(getColor("primary"), { a: 0.7 })),
    computedActiveColor: computed(() => getColor("primary"))
  };
};
export {
  useCarouselColor as u
};
//# sourceMappingURL=useCarouselColors-619fcd20.mjs.map
